import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";

import shipCore from "../core/ship.core";

export default function useCountryList() {
  const router = useRouter();
  return useQuery({
    queryKey: ["countryList", router.locale],
    queryFn: shipCore.getCountryList,
    enabled: router.isReady,
  });
}
